const Config = {
  yozyme: process.env.REACT_APP_YOZYME_URL,
  TwoWayAuth: process.env.REACT_APP_TWO_WAY_AUTH_URL,
  postgre_host: process.env.REACT_APP_POSTGRE_HOST_URL,
  express_host: process.env.REACT_APP_EXPRESS_HOST_URL,
  enquiry: process.env.REACT_APP_ENQUIRY_URL,
  devozy: process.env.REACT_APP_DEVOZY_URL,
  endpoint: {
    postgre: {
      user_signin: "/users/signIn",
      enquiry: "/subscription_web_enquiry",
      employee_twofactor_auth: "/employee_twofactor_auth",
      orgsubscriptiondetails:
        "/rpc/fun_orgsubscriptiondetails?useridentification=",
      userrole: "/subscription_roles_master",
      projectrallocation: "/agilesaas_project_mapping",
      issuedetails: "/agilesaas_issue_details",
      menumaster: "/agilesaas_menu_master",
    },
    express: {
      twofactauth: "/twofactauth",
      enquirysubmit: "/form/subscription_web_enquiry",
      enquiryget: "/subscription/subscription_web_enquiry",
      organizationdetails: "/subscription_client_details",
      subscriptiondetails: "/subscription_client_license_details",
      Subuser: "/subscription_client_users",
      Userrole: "/subscription_user_role_mapping",
      Sendmail: "/subscription/send-email",
      usercreation: "/subscription/usercreation",
      Role_master: "/subscription_roles_master",
      plan_master: "/subscription_plan_master",
      Product_master: "/subscription_product_master",
      Useractiveanddeactive: "/subscription/UserActivation",
      Agileemail: "/api/agile/email",
      Orgapprovalsettings: "/subscription_org_settings",
      Itsmgroup: "/agilesaas_itsmassignmentgroup_master",
      groupmap: "/subscription_user_group_mapping",
      projectmaster: "/agilesaas_project_master",
    },
  },
};

export default Config;
